import layoutHeaderAside from '@/layout/header-aside'
const meta = { auth: true }
export default {
  path: '/system/',
  name: 'system',
  meta,
  redirect: { name: 'system/backupData' },
  
  component: layoutHeaderAside,
  children: (pre => [
    {
        path: 'backupData',
        name: `${pre}backupData`,
        meta: {
          title: '数据备份',
          auth: true
        },
        component: () => import('@/views/system/dackupData') 
    },
    {
        path: 'startStop',
        name: `${pre}startStop`,
        meta: {
          title: '一键启停',
          auth: true
        },
        component: () => import('@/views/system/startStop') 
    },
    {
        path: 'runMonitor',
        name: `${pre}runMonitor`,
        meta: {
          title: '运行监控',
          auth: true
        },
        component: () => import('@/views/system/runMonitor') 
    },
    {
        path: 'auditLog',
        name: `${pre}auditLog`,
        meta: {
          title: '审计日志',
          auth: true
        },
        component: () => import('@/views/system/auditLog') 
    },

    //auditLog
    
])('system/')
}
